var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Inverse of the link-metadata fields written in
 * `chartLayout/communicationChartEdgeElements.ts` (`buildCommunicationChartEdgeElements`).
 *
 * Cytoscape edges store a flat `data` object; on edge tap we rebuild
 * `CommunicationChartLink` for the link inspector (see `useCommunicationChartCy`).
 */
var optionalStat = function (value) {
    if (value === undefined || value === null || value === '') {
        return undefined;
    }
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : undefined;
};
var parseHubChatKind = function (value) {
    return value === 'internalSpace' || value === 'internalDm' ? value : undefined;
};
export var getCommunicationChartLinkFromEdge = function (edge) {
    var data = edge.data();
    var hubChatKind = parseHubChatKind(data.hubChatKind);
    var sentCount = optionalStat(data.statsSentCount);
    var receivedCount = optionalStat(data.statsReceivedCount);
    return __assign(__assign({ sourceNodeId: Number(data.source), targetNodeId: Number(data.target) }, (hubChatKind !== undefined ? { hubChatKind: hubChatKind } : {})), { stats: __assign(__assign({ weight: Number(data.statsWeight), previousWeight: Number(data.statsPreviousWeight) }, (sentCount !== undefined ? { sentCount: sentCount } : {})), (receivedCount !== undefined ? { receivedCount: receivedCount } : {})) });
};
